import ButtonDialog from 'components/button-dialog/button-dialog';

export default ButtonDialog;
